import { useCallback } from 'react';
import { useAppContext } from '@magento/peregrine/lib/context/app';
export var useNavigationTrigger = () => {
  var [, {
    toggleDrawer
  }] = useAppContext();
  var handleOpenNavigation = useCallback(() => {
    toggleDrawer('nav');
  }, [toggleDrawer]);
  return {
    handleOpenNavigation
  };
};